import * as React from 'react';
import './App.css';
import { BrowserRouter, Route, Switch} from 'react-router-dom'

import Home from './components/LandingPageComponent'
import Contato from './components/ContactComponent'

export default () => {
    return(
        <BrowserRouter>
            <Switch>
                <Route path="/" exact render={props => <Home {...props} />} />
                <Route path="/home" exact render={props => <Home {...props} />} />
                <Route path="/contato" exact render={(props : any) => <Contato {...props} />} />
            </Switch>
        </BrowserRouter>
    )
}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/App.tsx